import { FC, memo, useMemo } from "react";
import styled from "styled-components";

import { RemoveButton } from "./ThumbnailsGenerator";
import { ReactComponent as TrashIcon } from "@/assets/icons/trashbin.svg";
import Text from "@/components/Text";
import { Input } from "@/components/Forms";

const ImagesRow = styled.div`
  display: flex;
  border-bottom: solid 1px ${({ theme }) => theme.colors.grayscale};
  padding: 16px 11px 16px 24px;
  border-right: 1px solid ${({ theme }) => theme.colors.grayscaleLight};
  width: 50%;
  &:nth-child(even) {
    border-right: 0;
  }
`;

const Img = styled.img`
  border-radius: 6px;
  width: 64px;
  height: 72px;
  flex-shrink: 0;
  margin-right: 18px;
  object-fit: cover;
`;

const InfoHolder = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  margin-right: 11px;
`;

const ImgTitle = styled(Text)`
  margin-bottom: 8px;
`;

const StyledInput = styled(Input)`
  font-size: 12px;
  height: 40px;
`;

interface Props {
  file: File;
  setTitleInputs: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string;
    }>
  >;
  title: string;
  index: number;
  setUploadedImages: React.Dispatch<React.SetStateAction<File[]>>;
}

const ThumbnailsImageRow: FC<Props> = memo(
  ({ file, setTitleInputs, title, index, setUploadedImages }) => {
    const imageSrc = useMemo(() => URL.createObjectURL(file), [file]);

    return (
      <ImagesRow>
        <Img src={imageSrc} alt="" />
        <InfoHolder>
          <ImgTitle $type="smallHeadline">{file.name}</ImgTitle>
          <StyledInput
            name={`imageTitle${index}`}
            placeholder="Add image name"
            value={title ?? ""}
            onChange={(e) =>
              setTitleInputs((prev) => {
                return {
                  ...prev,
                  [e.target.name]: e.target.value,
                };
              })
            }
          />
        </InfoHolder>
        <RemoveButton
          onClick={() => {
            setTitleInputs((prev) => {
              return {
                ...prev,
                [`imageTitle${index}`]: "",
              };
            });
            setUploadedImages((prev) =>
              prev?.filter((_, fileIndex) => fileIndex !== index)
            );
          }}
        >
          <TrashIcon />
        </RemoveButton>
      </ImagesRow>
    );
  }
);

export default ThumbnailsImageRow;
